/**
 * Tipo de aparato para el bloqueo de celular por rol (programa
 * "bloqueomovil" en rolesusuarios; lo aplica el backend al iniciar sesión).
 *
 * Teléfono = pantalla táctil cuyo lado corto mide menos de 600 px. Se mide
 * la pantalla y no el User-Agent porque el modo "ver versión de computadora"
 * del navegador disfraza el User-Agent pero no el tamaño. Las tablets
 * (lado corto ≥ 600) no cuentan como teléfono.
 */
export const PROGRAMA_BLOQUEO_MOVIL = "bloqueomovil";

export function tipoDispositivo() {
  try {
    const tactil = (navigator.maxTouchPoints || 0) > 0 || "ontouchstart" in window;
    const ladoCorto = Math.min(window.screen?.width || 0, window.screen?.height || 0);
    return tactil && ladoCorto > 0 && ladoCorto < 600 ? "telefono" : "otro";
  } catch (e) {
    return "otro";
  }
}
